import {
  Divider,
  Grid,
  InputAdornment,
  TextField,
  MenuItem,
  Button,
  Select,
  FormHelperText,
  ListSubheader,
} from '@material-ui/core'
import React, { useState } from 'react'
import FlexView from 'react-flexview/lib'
import { useForm, Controller } from 'react-hook-form'
import { EventEmitterService } from '../../services/EventEmitterService'
import {
  FirebaseConfigKey,
  FirebaseService,
} from '../../services/FirebaseService'
import { YesNoRadioButton } from '../Core/Buttons/ControlledRadioButtons'
import NewFillButton from '../Core/NewFillButton'
import { OptionalTag } from '../Core/OptionalTag'
import { MotocyclesApi } from '../../api/motorcycles.api'
import { SkyInformationPopover } from '../Core/Popover/SkyPopover'
import { FlatOutlinedButton } from '../Core/Buttons/FlatOutlinedButton'
import { prange } from '../../services/utils'
import { ReactComponent as MotorcycleSvg } from '../../assets/motorcycle.svg'

const most_common_make = [
  'BMW',
  'Ducati',
  'Harley-Davidson',
  'Honda',
  'Kawasaki',
  'Suzuki',
  'Triumph',
  'Yamaha',
]
const most_common_make_lower = most_common_make.map((k) => k.toLowerCase())

export const MotorcycleForm = ({
  defaultValues = {},
  SAVE_EVENT_KEY,
  onSave,
}) => {
  const { register, watch, trigger, setValue, errors, control, getValues } =
    useForm({
      defaultValues: {
        ...defaultValues,
        year: defaultValues.year || 'yeardefault',
        make: 'makedefault',
        model: 'modeldefault',
      },
      mode: 'onChange',
    })
  const [years, setYears] = useState([])
  const [makes, setMakes] = useState([])
  const [models, setModels] = useState([])
  const yearWatch = watch('year')
  const makeWatch = watch('make')
  const modelWatch = watch('model')
  const ccWatch = watch('engine_cc')

  const givenYear = defaultValues.year
  const givenMake = defaultValues.make
  const givenModel = defaultValues.model

  const fetchModels = async (inputMake, inputYear) => {
    let res = await MotocyclesApi.getModels(inputMake, inputYear)
    if (res.ok) {
      setModels(res.parsedData.motorcycle_models)
      if (givenModel) {
        setValue('model', givenModel)
      }
    }
  }

  const fetchCC = async (inputCC, inputYear) => {
    let res = await MotocyclesApi.getModelCC(inputCC, inputYear)
    if (res.ok) {
      setValue('engine_cc', res.parsedData.motorcycle_cc)
    }
  }

  const fetchMakes = async (inputYear) => {
    let res = await MotocyclesApi.getMakes(inputYear)
    if (res.ok) {
      setMakes(
        res.parsedData.motorcycle_makes.filter(
          (word) => !most_common_make_lower.includes(word.toLowerCase())
        )
      )
      if (givenMake) {
        setValue('make', givenMake)
      }
    }
  }

  const fetchYears = async () => {
    let res = await MotocyclesApi.getModelYears()
    if (res.ok) {
      setYears(res.parsedData.motorcycle_years)
    }
  }

  const onFormSubmit = async () => {
    let valid = await trigger()

    if (!valid) return

    onSave(getValues())
  }

  React.useEffect(() => {
    // register({ name: 'year' });
    register({ name: 'make' })
    register({ name: 'model' })
    register({ name: 'engine_cc' })
  }, [register])

  React.useEffect(() => {
    setModels([])
    setMakes([])
    setValue('model', 'modeldefault')
    setValue('make', 'makedefault')

    let inputYear = getValues()['year']
    if (inputYear && inputYear != 'yeardefault') {
      fetchMakes(inputYear)
    }
  }, [yearWatch])

  React.useEffect(() => {
    setModels([])
    setValue('model', 'modeldefault')

    let inputMake = getValues()['make']
    let inputYear = getValues()['year']
    if (
      inputYear &&
      inputYear != 'yeardefault' &&
      inputMake &&
      inputMake != 'makedefault'
    ) {
      fetchModels(inputMake, inputYear)
    }
  }, [makeWatch])

  React.useEffect(() => {
    let inputModel = getValues()['model']
    let inputYear = getValues()['year']
    if (
      inputYear &&
      inputYear != 'yeardefault' &&
      inputModel &&
      inputModel != 'modeldefault'
    ) {
      fetchCC(inputModel, inputYear)
    }
  }, [modelWatch])

  React.useEffect(() => {
    fetchYears()
    register('id')
    let id = EventEmitterService.subscribe(SAVE_EVENT_KEY, async () => {
      onFormSubmit()
    })

    return function cleanup() {
      EventEmitterService.unsubscribe(SAVE_EVENT_KEY, id)
    }
  }, [])

  return (
    <div className="motorcycle-form">
      <FlexView vAlignContent={'center'} className="margin-bottom-basic">
        <MotorcycleSvg className="large-icon margin-right-6" />
        <div className="text-title bold black">
          Tell us about your motorcycle
        </div>
      </FlexView>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <div className="full-width">
            <Controller
              disabled={years.length == 0}
              rules={{
                required: true,
                validate: (x) => x && x != 'yeardefault',
              }}
              name="year"
              as={
                <TextField
                  inputRef={{
                    required: true,
                    validate: (x) => x && x != 'yeardefault',
                  }}
                  error={!!errors.year}
                  fullWidth
                  label="Model Year"
                  select
                  variant="outlined"
                  className="">
                  <MenuItem disabled value={'yeardefault'}>
                    <div className="placeholder-text">Model Year</div>
                  </MenuItem>
                  {years.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </TextField>
              }
              control={control}
            />
            {!!errors.year && (
              <FormHelperText error={!!errors.year}>Required</FormHelperText>
            )}
            {/* <TextField name="year"  style={{height: 0, width:0}} /> */}
          </div>

          {/* <TextField fullWidth variant="outlined" label="Type" name="type" inputRef={register({required: true})} error={!!errors.type} helperText={errors.type && errors.type.type} /> */}
        </Grid>
        {makes.length > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <div className="full-width">
              <Controller
                disabled={makes.length == 0}
                rules={{
                  required: true,
                  validate: (x) => x && x != 'makedefault',
                }}
                name="make"
                as={
                  <TextField
                    inputRef={{
                      required: true,
                      validate: (x) => x && x != 'makedefault',
                    }}
                    error={!!errors.make}
                    fullWidth
                    label="Make"
                    select
                    variant="outlined"
                    className="">
                    <MenuItem disabled value={'makedefault'}>
                      <div className="placeholder-text">Make</div>
                    </MenuItem>
                    <ListSubheader disableSticky>
                      <div className="text-small-title black bolder">
                        Most Common Manufacturers
                      </div>
                    </ListSubheader>
                    {most_common_make.map((item) => (
                      <MenuItem
                        className="margin-left-basic"
                        key={item}
                        value={item.toUpperCase()}>
                        {item.toUpperCase()}
                      </MenuItem>
                    ))}
                    <ListSubheader disableSticky>
                      <div className="text-small-title black bolder">
                        All Manufacturers
                      </div>
                    </ListSubheader>
                    {makes.map((item) => (
                      <MenuItem
                        className="margin-left-basic"
                        key={item}
                        value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                }
                control={control}
              />
              {!!errors.make && (
                <FormHelperText error={!!errors.make}>Required</FormHelperText>
              )}
              {/* <TextField name="make" style={{height: 0, width:0}} /> */}
            </div>

            {/* <TextField type='number' fullWidth variant="outlined" label="Year" name="year" inputRef={register({required: true})} error={!!errors.year} helperText={errors.year && errors.year.type} /> */}
          </Grid>
        )}
        {models.length > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <div className="full-width">
              <Controller
                disabled={models.length == 0}
                rules={{
                  required: true,
                  validate: (x) => x && x != 'modeldefault',
                }}
                name="model"
                as={
                  <TextField
                    inputRef={{
                      required: true,
                      validate: (x) => x && x != 'modeldefault',
                    }}
                    error={!!errors.model}
                    fullWidth
                    label="Model"
                    select
                    variant="outlined"
                    className="">
                    <MenuItem disabled value={'modeldefault'}>
                      <div className="placeholder-text">Model</div>
                    </MenuItem>
                    {models.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                }
                control={control}
              />
              {!!errors.model && (
                <FormHelperText error={!!errors.model}>Required</FormHelperText>
              )}
              {/* <TextField name="model" style={{height: 0, width: 0}} /> */}
            </div>
          </Grid>
        )}

        {/* <TextField fullWidth variant="outlined" label="Make" name="make" inputRef={register({required: true})} error={!!errors.make} helperText={errors.make && errors.make.type} /> */}
      </Grid>
      <Grid container spacing={2} className="margin-top-basic">
        <Grid item xs={12} sm={6} md={3}>
          <FlexView vAlignContent={'center'}>
            <TextField
              fullWidth
              variant="outlined"
              label="Zip code"
              name="zip"
              inputRef={register({ required: true })}
              error={!!errors.zip}
            />
            <SkyInformationPopover eventId={'motor-zipcode-popover'}>
              <div className="text-small">Zip code where vehicle is kept</div>
            </SkyInformationPopover>
          </FlexView>
        </Grid>
        {Number.parseInt(yearWatch) > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <FlexView vAlignContent={'center'}>
              <div className="full-width">
                <Controller
                  control={control}
                  rules={{
                    validate: (x) => x && x != 'default',
                    required: true,
                  }}
                  name="less_than_year_acquired"
                  defaultValue={defaultValues.less_than_year_acquired}
                  as={
                    <TextField
                      error={!!errors.less_than_year_acquired}
                      variant="outlined"
                      fullWidth
                      label="When Acquired?"
                      select>
                      <MenuItem disabled value={'default'}>
                        <div className="placeholder-text">When Acquired?</div>
                      </MenuItem>
                      <MenuItem value={'true'}>Less than 1 year ago</MenuItem>
                      <MenuItem value={'false'}>1 or more years ago</MenuItem>
                    </TextField>
                  }
                />
                {!!errors.less_than_year_acquired && (
                  <FormHelperText error={!!errors.less_than_year_acquired}>
                    Required
                  </FormHelperText>
                )}
              </div>
              <SkyInformationPopover eventId={'motor-zipcode-popover'}>
                <div className="text-small">
                  How many years have you owned your bike?
                </div>
              </SkyInformationPopover>
              {/* <TextField type='number' fullWidth variant="outlined" label="Acquired year" name="acquired_year" inputRef={register({required: true, minLength: 4, maxLength:4})} error={!!errors.acquired_year} /> */}
              {/* <SkyInformationPopover eventId={'motor-acquired-year-popover'}>
                            <div className='text-small'>What year was this vehicle acquired?</div>
                    </SkyInformationPopover> */}
            </FlexView>
          </Grid>
        )}
        {modelWatch != 'modeldefault' && (
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              InputLabelProps={{ shrink: !!ccWatch }}
              disabled
              type="number"
              fullWidth
              variant="outlined"
              label="CC size"
              name="engine_cc"
              inputRef={register({ required: true })}
              error={!!errors.engine_cc}
              helperText={errors.engine_cc && errors.engine_cc.type}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <Controller
            control={control}
            rules={{ validate: (x) => x && x != 'default' }}
            name="accessory_value"
            defaultValue={defaultValues.accessory_value || 'default'}
            as={
              <TextField
                // InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}}
                error={!!errors.accessory_value && 'Required'}
                variant="outlined"
                fullWidth
                label="Accessory Value (optional)"
                select>
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text">Accessory Value</div>
                </MenuItem>
                {prange(0, 10500, 500).map((val) => (
                  <MenuItem value={val}>
                    {FirebaseService.getValue(
                      FirebaseConfigKey.CURRENCY_SYMBOL
                    )}
                    {val.toLocaleString()}
                  </MenuItem>
                ))}
              </TextField>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            label="Sidecar value"
            name="side_car_value"
            inputRef={register}
            error={!!errors.side_car_value}
            helperText={errors.side_car_value && errors.side_car_value.type}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {' '}
                  <OptionalTag />{' '}
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            label="Trailer value"
            name="trailer_value"
            inputRef={register}
            error={!!errors.trailer_value}
            helperText={errors.trailer_value && errors.trailer_value.type}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {' '}
                  <OptionalTag />{' '}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <div className="text-body margin-top-basic black bold">
        Your monthly insurance cost depends on how many miles you actually
        drive.
      </div>
      <div className="text-small black margin-top-6">
        How many miles do you expect to drive in the upcoming year?
      </div>
      <FlexView
        vAlignContent={'center'}
        className="margin-top-basic margin-bottom-basic">
        <TextField
          type={'number'}
          variant="outlined"
          label="Miles per year"
          name="miles_per_year"
          inputRef={register}
          error={!!errors.miles_per_year}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {' '}
                <OptionalTag />{' '}
              </InputAdornment>
            ),
          }}
        />
        <SkyInformationPopover eventId={'per-mile-popover'}>
          <div className="text-small">
            We will use this information to estimate your monthly insurance
            cost.
          </div>
          <div className="text-small">
            Your monthly insurance cost will increase or decrease depending on
            the miles you drive. The lower the mileage, the lower the cost.
          </div>
        </SkyInformationPopover>
      </FlexView>

      <Divider />
      <YesNoRadioButton
        label={'Does your motorcycle have anti-lock brakes?'}
        name="anti_lock_brakes"
        discount
        defaultValue={defaultValues['anti_lock_brakes']}
        register={register}
        control={control}
        errors={errors}
        watch={watch}
      />
      <YesNoRadioButton
        label={'Does your motorcycle have anti-theft devices?'}
        name="anti_theft_device"
        discount
        defaultValue={defaultValues['anti_theft_device']}
        register={register}
        control={control}
        errors={errors}
        watch={watch}
      />
      <FlexView hAlignContent={'center'} className="margin-top-basic">
        {/* <Button onClick={onFormSubmit} className='text-body glowgreen bold' style={{textTransform: 'none'}} type='submit'>Save</Button> */}
        <NewFillButton onClick={onFormSubmit} flat>
          Save
        </NewFillButton>
      </FlexView>
    </div>
  )
}
